import { render } from "./NotFound.vue?vue&type=template&id=608f6e0d&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=608f6e0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-608f6e0d"

export default script